import { render, staticRenderFns } from "./ToolHelpForum.vue?vue&type=template&id=1fa2fa45&scoped=true"
import script from "./ToolHelpForum.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolHelpForum.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolHelpForum.vue?vue&type=style&index=0&id=1fa2fa45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2fa45",
  null
  
)

export default component.exports